"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _assertThisInitialized = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");
var _possibleConstructorReturn = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _get = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");
var _inherits = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _getPrototypeOf = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _set = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/set");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _superPropSet(t, e, o, r, p, f) { return _set(_getPrototypeOf(f ? t.prototype : t), e, o, r, p); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ContentShareConstants_1 = require("../contentsharecontroller/ContentShareConstants");
var VideoPreference_1 = require("./VideoPreference");
var VideoPreferences_1 = require("./VideoPreferences");
var VideoPriorityBasedPolicy_1 = require("./VideoPriorityBasedPolicy");
var VideoAdaptiveProbePolicy = /*#__PURE__*/function (_VideoPriorityBasedPo) {
  _inherits(VideoAdaptiveProbePolicy, _VideoPriorityBasedPo);
  function VideoAdaptiveProbePolicy(logger) {
    var _this;
    _classCallCheck(this, VideoAdaptiveProbePolicy);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(VideoAdaptiveProbePolicy).call(this, logger));
    _this.logger = logger;
    _superPropSet((_assertThisInitialized(_this), VideoAdaptiveProbePolicy), "shouldPauseTiles", false, _assertThisInitialized(_this), 1, 1);
    _this.videoPreferences = undefined;
    return _this;
  }
  _createClass(VideoAdaptiveProbePolicy, [{
    key: "reset",
    value: function reset() {
      _superPropGet(VideoAdaptiveProbePolicy, "reset", this, 3)([]);
      _superPropSet(VideoAdaptiveProbePolicy, "shouldPauseTiles", false, this, 1, 1);
      this.videoPreferences = undefined;
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(videoIndex) {
      _superPropGet(VideoAdaptiveProbePolicy, "updateIndex", this, 3)([videoIndex]);
      var newPreferences = VideoPreferences_1.VideoPreferences.prepare();
      var containsContent = false;
      var remoteInfos = videoIndex.remoteStreamDescriptions();
      // If there is active content then set that as high priority, and the rest at lower
      var _iterator = _createForOfIteratorHelper(remoteInfos),
        _step;
      try {
        var _loop = function _loop() {
          var info = _step.value;
          // I don't know why we need to do this duplicate check.
          if (!newPreferences.some(function (preference) {
            return preference.attendeeId === info.attendeeId;
          })) {
            // For now always subscribe to content even if higher bandwidth then target
            if (info.attendeeId.endsWith(ContentShareConstants_1.default.Modality)) {
              newPreferences.add(new VideoPreference_1.default(info.attendeeId, 1));
              containsContent = true;
            } else {
              newPreferences.add(new VideoPreference_1.default(info.attendeeId, 2));
            }
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (containsContent) {
        this.videoPreferences = newPreferences.build();
        this.videoPreferencesUpdated = true;
      } else {
        this.videoPreferences = undefined;
      }
    }
    /**
     * [[VideoAdaptiveProbePolicy]] does not allow setting video preferences and this function
     * will be a no-op.  Please use [[VideoPriorityBasedPolicy]] directly if you would like to set
     * preferences.
     */
  }, {
    key: "chooseRemoteVideoSources",
    value: function chooseRemoteVideoSources(_preferences) {
      this.logger.error('chooseRemoteVideoSources should not be called by VideoAdaptiveProbePolicy');
      return;
    }
  }]);
  return VideoAdaptiveProbePolicy;
}(VideoPriorityBasedPolicy_1.default);
exports.default = VideoAdaptiveProbePolicy;